/* eslint-disable jsx-a11y/label-has-associated-control */

import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import React, { useState } from "react";

import {
    Box,
    Card,
    Grid,
    Container,
    CardContent,
    CardActions,
} from "@mui/material";

import { styles } from "./style";
import Iconify from "../../components/iconify/iconify";
import LoadingButton from "../../shared/loadingButton/LoadingButton";
import { getErrorMessage } from "../../utils";
import ByLawsServices from "../../services/ByLawsServices";

const CreateByLaws = () => {
    const navigate = useNavigate();

    const [memberImage, setMemberImage] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const handleFileChange = (e) => {
        const file = e.target.files[0];

        const fileSize = file.size / (1024 * 1024);
        if (fileSize > 3) {
            toast.error("File size exceeds the maximum limit of 3 MB.");
            return;
        }
        setMemberImage(file);
    };

    const handleSubmit = async () => {
        const dataToSend = {
            file: memberImage,
        };
        setIsLoading(true);
        ByLawsServices.create(dataToSend)
            .then(() => {
                toast.success("By Laws created successfully");
                setIsLoading(true);

                navigate(-1);
            })
            .catch((err) => {
                toast.error(getErrorMessage(err));
                setIsLoading(false);
            });
    };

    return (
        <Container>
            <Card sx={{ padding: "1rem" }}>
                <CardContent>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <Box sx={styles.mainWrapper}>
                                <Box sx={styles.iconWrapper}>
                                    <label
                                        htmlFor="staff_profile_img"
                                        style={styles.staffUploadIcon}
                                    >
                                        <Iconify
                                            sx={{ width: "15px", height: "15px" }}
                                            icon="ic:edit"
                                        />
                                    </label>
                                    <input
                                        type="file"
                                        name="staffProfileImage"
                                        id="staff_profile_img"
                                        style={{ display: "none" }}
                                        onChange={handleFileChange}
                                    />
                                </Box>
                                <Box sx={styles.imageWrapper}>
                                    {memberImage && (
                                        <Box sx={{ width: "100%", height: "100%" }}>
                                            <img
                                                height="100%"
                                                src={URL.createObjectURL(memberImage)}
                                                alt="staff"
                                            />
                                        </Box>
                                    )}
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                </CardContent>
                <CardActions>
                    <LoadingButton
                        isLoading={isLoading}
                        variant="contained"
                        onClick={handleSubmit}
                    >
                        Add ByLaws
                    </LoadingButton>
                </CardActions>
            </Card>
        </Container>
    );
};

export default CreateByLaws;
